module.exports = __webpack_public_path__ + "img/sitobion-miscanthi.22157131.jpg";